var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"push-button",attrs:{"to":_vm.to}},[_c('div',{staticClass:"background",class:_vm.background}),_c('div',{staticClass:"label"},_vm._l((_vm.labelLines),function(line,index){return _c('span',{key:index},[_vm._v(_vm._s(line))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }